<template>
  <v-layout>
    <v-main>
      <v-container
          class="fill-height"
          fluid
      >
        <v-row
            align="center"
            justify="center"
        >
          <v-col
              cols="12"
              md="4"
              sm="8"
          >
            <v-form @submit.prevent="login()">
              <v-card class="elevation-12">
                <v-toolbar
                    color="primary"
                    dark
                    flat
                >
                  <v-toolbar-title>Vital Developers Login</v-toolbar-title>
                  <div class="flex-grow-1"></div>
                </v-toolbar>
                <v-card-text>
                  <v-text-field
                      v-model="username"
                      :error="error"
                      label="Username"
                      name="username"
                      prepend-icon="mdi-account"
                      type="text"
                  ></v-text-field>
                  <v-text-field
                      id="password"
                      v-model="password"
                      :error="error"
                      label="Password"
                      name="password"
                      prepend-icon="mdi-lock"
                      type="password"
                  ></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn color="primary" type="submit">Login</v-btn>
                </v-card-actions>
              </v-card>
            </v-form>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-layout>
</template>

<script>
import {errorNotification} from "@/components/utils";

export default {
  components: {},
  data() {
    return {
      username: '',
      password: '',
      error: false,
      message: ''
    }
  },
  methods: {
    login() {
      this.$store.dispatch('auth/login', {
        username: this.username,
        password: this.password
      }).then(() => {
        this.$router.replace(this.$route.query.redirect || '/')
      }).catch((error) => {
        this.error = true
        this.message = error
        errorNotification(error)
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
